module.exports = __webpack_public_path__ + "static/media/forestProject.d0b6091d.jpg";